import React from "react";
import { getWPData, REBUILD_TIMEOUT } from "../lib";
import logger from "../lib/logger";
import { WidgetPage } from "../widgets";

export default function GlossaryOfTerms(props) {
  return <WidgetPage {...props} />;
}

export async function getStaticProps() {
  const slug = "pages/2765";
  const data = await getWPData(slug, true);

  if (!data) {
    logger.error(`No Wordpress data found for ${slug}, page will render empty`);
  }

  return {
    revalidate: REBUILD_TIMEOUT,
    props: {
      data: data || [],
      layoutProps: {
        isLightHeader: false,
        isWhiteBody: true,
        navColour: "white",
      },
    },
  };
}
